import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { FormikProps } from 'formik';
import { IApplicationDetails } from '../../constants/new-application/new-application-form';
import { scrollToError } from '../../utils/formikUtils';
import { STATUSES } from '../../views/login/Login';
import { useMerchants } from '../../store/merchnts/merchants-context';
import clsx from 'clsx';

interface Props {
  formik: FormikProps<IApplicationDetails>;
  formEditStatus: boolean;
  applicationStatus: STATUSES;
  isClicked: boolean;
  saveAndSendModalOpen: () => void;
  onSave: (send?: boolean) => Promise<void>;
}

const NewApplicationFooter = (props: Props): React.ReactElement => {
  const {
    formik,
    formEditStatus,
    applicationStatus,
    isClicked,
    saveAndSendModalOpen,
    onSave,
  } = props;
  const { t } = useTranslation();

  const { merchantState: { applicationData, isReinviteLoading }} = useMerchants();

  const [needScroll, setNeedScroll] = useState<boolean>(true);

  // useEffect(() => {
  //   const errors = Object.keys(formik.errors)?.length;
  //   if (errors && needScroll) {
  //     console.log('errors__1', formik.errors);
  //     scrollToError(formik.errors);
  //     setNeedScroll(false);
  //   }
  // }, [formik.errors]);

  const handleSaveButtonClick = async (): Promise<void> => {
    formik.handleSubmit();
    const errors = await formik.validateForm();
    if (Object.keys(errors).length === 0) {
      onSave();
    } else {
      setNeedScroll(true);
      scrollToError(errors);
    }
  };

  const handleSaveAndSendButtonClick = async (): Promise<void> => {
    formik.handleSubmit();
    const errors = await formik.validateForm();
    if (Object.keys(errors).length === 0 || !formEditStatus) {
      saveAndSendModalOpen();
    } else {
      setNeedScroll(true);
      scrollToError(errors);
    }
  };

  // const handleClick = async (): Promise<void> => {
  //   if (!applicationData?.primaryContact?.userCreated) {
  //     await handleSaveAndSendButtonClick();
  //   } else {
  //     await reInviteUser({ dispatch, applicationId });
  //   }
  // };

  // const getButtonName = (): string => {
  //   if (!applicationData?.primaryContact?.userCreated && formEditStatus) {
  //     return t('NEW_APPLICATION.SAVE_AND_SEND_BUTTON');
  //   } else if (!applicationData?.primaryContact?.userCreated && !formEditStatus) {
  //     return t('NEW_APPLICATION.SEND_BUTTON');
  //   } else {
  //     return 'Reinvite';
  //   }
  // };

  return (
    <div className="d-sm-flex align-items-center justify-content-end">
      <ButtonComponent
          buttonType={BUTTON_TYPE.WHITE}
          buttonName={t('NEW_APPLICATION.SAVE_BUTTON')}
          additionalClass="mb-5 mb-sm-0 save-btn-width d-block w-100 d-sm-inline-block w-sm-auto"
          onButtonClick={(): Promise<void> => !isClicked && handleSaveButtonClick()}
          isDisabled={!formEditStatus || ![STATUSES.IN_REVIEW, STATUSES.DRAFT, STATUSES.CANCELLED]?.includes(applicationStatus)}
          loading={isClicked}
      />

      {
        !applicationData?.primaryContact?.userCreated && (
          <ButtonComponent
            // buttonName={getButtonName()}
            buttonName={t('NEW_APPLICATION.SAVE_AND_SEND_BUTTON')}
            additionalClass={clsx(
              'ms-sm-5 mb-5 mb-sm-0 btn-sm d-block w-100 d-sm-inline-block',
              applicationData?.primaryContact?.userCreated && !applicationData?.primaryContact?.confirmedUser
                ? 'w-sm-100px'
                : 'w-sm-auto'
              )}
            onButtonClick={async ():Promise<void> => await handleSaveAndSendButtonClick()}
            isDisabled={!formEditStatus || ![STATUSES.IN_REVIEW, STATUSES.DRAFT]?.includes(applicationStatus) || isClicked}
            loading={isReinviteLoading}
          />
        )
      }
    </div>
  );
};

export default NewApplicationFooter;
